// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-2bdf7d6a","scoped":true,"hasInlineConfig":false}!./src/components/entry-points/create-new-entry-point/chat-panel/ChatPanel.css
// module id = zB5D
// module chunks = 1